import React from 'react';
import { Link } from 'react-router-dom';

const LinkedTable = ({ purchases }) => (
  <table className="table">
    <thead>
      <tr>
        <th>ID</th>
        <th>Charge Type</th>
        <th>Status</th>
        <th>Total</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {purchases.length > 0 &&
        purchases.map((purchase) => (
          <tr key={purchase.id}>
            <td>{purchase.id}</td>
            <td>{purchase.charge_type}</td>
            <td className="text-uppercase">{purchase.status}</td>
            <td>${purchase.total}</td>
            <td>
              <Link to={`/purchases/${purchase.id}/view`}>View</Link>
            </td>
          </tr>
        ))}
    </tbody>
  </table>
);

const LinkedPurchases = ({ purchase }) => {
  const { linked_from, linked_to } = purchase;

  return (
    <React.Fragment>
      {linked_from.length > 0 ? (
        <React.Fragment>
          <h4>Linked From:</h4>
          <LinkedTable purchases={linked_from} />
        </React.Fragment>
      ) : null}

      {linked_to ? (
        <React.Fragment>
          <h4>Linked To:</h4>
          <LinkedTable purchases={[linked_to]} />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default LinkedPurchases;
